<div class="growth-score-card-container">
  <div class="growth-score-card-content">
    <div class="growth-score-card-header">
      <div class="growth-score-card-header__title">
        <h2 class="growth-score-card-header__title-text">{{ cardTitle }}</h2>
        <growth-report-cel-icon-button
          *ngIf="isClassMetric || isStudentMetric"
          class="growth-score-card-header__icon-and-popover"
          [ngClass]="{
            'info-icon-popover-class-metric': isClassMetric,
            'info-icon-popover-student-metric': isStudentMetric
          }"
          [attr.data-name]="iconDetails.NAME_INFORMATION_CIRCLE"
          [attr.data-tooltip-text]="'popover-tooltip-label' | translate"
          [attr.data-identifier]="iconDetails.END_TO_END_ID"
          [attr.data-color]="iconDetails.COLOR_GRAYDARKER"
          [attr.data-size]="iconDetails.SIZE_REGULAR"
          data-has-popover="true"
          [popoverConfig]="popoverConfig"
          data-icon-button-aria-haspopup="false"
          [attr.data-focus-element]="shouldFocusInfoIcon"
          (celIconButtonPopoverWindowClick)="setInfoIconFocus(true)"
          (celButtonOnClick)="setInfoIconFocus(false)"
        ></growth-report-cel-icon-button>
      </div>
      <growth-report-cel-single-select
        *ngIf="showDomainDropdown && (isLoading$ | async) === false"
        class="single-select-dropdown"
        data-primary="true"
        [placeholder]="'common.select-an-option-placeholder' | translate"
        [attr.data-single-select-aria-label]="'common.select-an-option-placeholder' | translate"
        [menuList]="dropdownProperties.dropdownMenu"
        [selected]="dropdownProperties.selectedOption"
        (celSingleSelect)="domainSelectionChange($event)"
        (singleSelectItemClicked)="domainSelectionChange($event)"
      ></growth-report-cel-single-select>
    </div>
    <ng-container *ngIf="(isLoading$ | async) === false">
      <div
        class="growth-score-card-score"
        *ngIf="!isDashVisible; else noGrowthScoreTemplate"
        [ngClass]="{ 'growth-score-card-score-metric': isClassMetric || isStudentMetric }"
      >
        {{ cardScore }}
      </div>
      <ng-template #noGrowthScoreTemplate>
        <div class="no-data-display-score"></div>
      </ng-template>
      <div
        class="growth-score-card-message"
        [ngClass]="{ 'growth-score-card-zero-state-message': showZeroStateMessage }"
      >
        {{ cardMessage }}
      </div>
    </ng-container>
  </div>
</div>
